export enum ProtectedCollectionType {
  None = 0,
  Users = 1,
  Functions = 2,
  Departments = 3,
  Roles = 4,
  DepartmentDepartments = 5,
  DepartmentFunctions = 6,
  DepartmentUsers = 7,
  FunctionDepartments = 8,
  FunctionFunctions = 9,
  FunctionUsers = 10,
  RoleDepartments = 11,
  RoleFunctions = 12,
  RoleUsers = 13,
  LinkTrainingSkill = 21,
  LinkTrainingExam = 22,
  LinkTrainingDocument = 23,
  LinkDocumentSkill = 24,
  LinkDocumentExam = 25,
  Skills = 26,
  Exams = 27,
  Trainings = 28,
  SkillGrades = 29,
  TrainingSessions = 30,
  LinkTrainingTrainingsessions = 31,
  SkillCategories = 32,
  LinkSkillSkillCategory = 33,
  TrainingCategories = 34,
  LinkTrainingTrainingCategory = 35,
  LinkDocumentTraining = 36,
  TrnDocumentCollection = 37,
  Costs = 38,
  LinkTrainingCosts = 39,
  LinkTrainingSessionCosts = 40,
  Trainers = 41,
  LinkTrainingTrainers = 42,
  TrainingSessionsLessons = 43,
  LinkTrainingSessionLessons = 44,
  LinkTrainingSessionsTrainingsTrainers = 45,
  TrainingAttachments = 46,
  LinkTrainingTrainingAttachments = 47,
  LinkTrainingSessionTrainingAttachments = 48,
  ExamSessions = 49,
  ExamCategories = 50,
  LinkExamsExamCategories = 51,
  QualificationCategories = 52,
  LinkExamsExamQualification = 53,
  LinkExamSessionsExams = 54,
  ExamQuestionsAndAnswers = 55,
  LinkQuestionsAndAnswersExamSession = 56,
  LinkExamsSkills = 57,
  LinkTrainingSessionSkill = 58,
  LinkTrainingSessionExam = 59,
  LinkQualificationCategories = 60,
  Qualification = 61,
  LinkQualificationSkill = 62,
  QualificationCertificates = 63,
  UserQualification = 64,
  LinkUserQualificationQualification = 66,
  LinkUserQualificationQualificationCertificate = 67,
  LinkTrainingSessionQualification = 68,
  LinkTrainingQualification = 69,
  LinkDocumentQualification = 70,
  LinkUsersDefaultEntity = 101,
  AiCosts = 102,
  AiProcess = 103,
  LinkProcessToCosts = 104,
  ChkMainCollecton = 200,
  ChkQuestionCategories = 201,
  ChkTemplates = 202,
  ChkQuestions = 203,
  ChkResultClass = 204,
  ChkAttachments = 205,
  ChkQuestionAndAnswers = 206,
  ChkLinkTemplatesQuestions = 207,
  ChkLinkQuestionsQuestionsCategory = 208,
  ChkLinkQuestionsResultClass = 209,
  ChkLinkQuestionsAndAnswersMainCollection = 210,
  ChkLinkMainCollectionTemplates = 211,
  ChkLinkQuestionsAndAnswersAttachmentsCollection = 212,
  ChkLinkMainCollectionQuestions = 213
}